import { createStore } from 'vuex';
import axios from 'axios';

const store = createStore({
  state: {
    isAdmin: false,
    admin: false,
    loading: false,
    user: {},
    objects: [],
    object: {},
    deleteIndent: false,
  },
  mutations: {
    changeLoading(state, value) {
      state.loading = value;
    },
    setUser(state, value) {
      state.user = value;
    },
    setObjects(state, value) {
      state.objects = value;
    },
    setAdmin(state, isAdmin) {
      state.isAdmin = isAdmin;
    },
    toggleAdmin(state) {
      state.admin = !state.admin;
    },
    writeOpenCard(state, object) {
      state.object = object;
    },
    deleteIndent(state, value) {
      state.deleteIndent = value;
    },
  },
  actions: {
    async checkInitData({ commit }, token) {
      try {
        const response = await axios.post('/api/checkInitData', token, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        commit('setUser', response.data.user);
      } catch (error) {
        console.error('Ошибка при проверке статуса администратора:', error);
      }
    },
    async checkAdminStatus({ commit }, userId) {
      try {
        const response = await axios.get(`/api/check_admin/${userId}`);
        commit('setAdmin', response.data.is_admin);
      } catch (error) {
        console.error('Ошибка при проверке админства:', error);
      }
    },
    async getObjects({ commit }) {
      try {
        const response = await axios.get('api/getObjects');
        commit('setObjects', response.data);
      } catch (error) {
        console.error('Ошибка при получении объектов:', error);
      }
    },
    async deleteObject({ dispatch }, objectId) {
      try {
        await axios.post('/api/removeObjects', { id: objectId });
        await dispatch('getObjects');
      } catch (error) {
        console.error('Ошибка при удалении объекта:', error);
      }
    },
    async updateObject({ dispatch }, data) {
      try {
        await axios.post('/api/editObjects', data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        await dispatch('getObjects');
      } catch (error) {
        console.error('Ошибка при обновлении объекта:', error);
      }
    },
    async addObject({ dispatch, commit }, formData) {
      try {
        await axios.post('/api/addObjects', formData);
        await dispatch('getObjects');
      } catch (error) {
        commit('setInfo', error);
        console.error('Ошибка при добавлении объекта:', error);
      }
    },
    async submitForm(context, formData) {
      try {
        await axios.post('/api/addFormUser', formData);
      } catch (error) {
        console.error('Ошибка при отправке заявки:', error);
      }
    },
  },
});
export default store;
